import styled from 'styled-components';
import {
  CredusAlert,
  CredusButton,
  CredusHeading,
  CredusInput,
  CredusText,
  CredusWrapper,
  CredusInputPassword,
  color,
} from 'ui';
import { Divider } from 'antd';
import { Link } from 'react-router-dom';
import { OnBoardLogo } from '../assets/images/svgs';
import useLogin from '../hooks/useLogin';

const AdminLogin: React.FC = () => {
  const { formik, apiError, isLoading, handleCloseAlert } = useLogin();

  return (
    <Container>
      <OnBoardLogo />
      <Wrapper mt="2rem" display="flex" flex="1" justify="center">
        <Wrapper
          pl="1rem"
          display="flex"
          direction="column"
          justify="space-between"
          w="40%"
        >
          <div>
            <CredusHeading
              className="slideBottom"
              as="h3"
              align="center"
              weight="medium"
            >
              <ColoredText>Welcome</ColoredText> Admin,
            </CredusHeading>
            <FormWrap onSubmit={formik.handleSubmit}>
              <CredusHeading as="h4" align="center" weight="medium">
                Login your details
              </CredusHeading>
              {apiError && (
                <AlertWrapper>
                  <CredusAlert
                    type="error"
                    message={apiError}
                    show={!!apiError}
                    onCancel={handleCloseAlert}
                  />
                </AlertWrapper>
              )}
              <Wrapper mt="2.4rem">
                <CredusInput
                  type="email"
                  label="Email Address"
                  name="userName"
                  placeholder="e.g student@credusapp.com"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.userName}
                  error={formik.errors.userName}
                />
              </Wrapper>
              <PasswordWrap>
                <CredusInputPassword
                  label="Password"
                  name="password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                  error={formik.errors.password}
                />
              </PasswordWrap>
              <CredusButtonWrap
                variant="primary"
                size="medium"
                disabled={isLoading}
              >
                Login
              </CredusButtonWrap>
              <Wrapper mt="2rem" display="flex" align="center" justify="center">
                <Link to="/forgot-password">
                  <CredusText size="md" weight="medium" align="center">
                    Forgot Password?
                  </CredusText>
                </Link>
                <DividerWrap type="vertical" />
                <CredusText size="md" weight="medium" align="center">
                  Request access
                </CredusText>
              </Wrapper>
            </FormWrap>
          </div>
          <Wrapper>
            <CredusText mt="3.2rem" size="md" weight="regular" align="center">
              Having technical difficulties ? Say hello to
              <WrappedLink to="mailto:credussupport@mail.com" target="_blank">
                credussupport@mail.com
              </WrappedLink>
            </CredusText>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    </Container>
  );
};

export default AdminLogin;

const Container = styled.div`
  background: #fff;
  padding: 2.8rem 5rem 3rem 7rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
`;

const Wrapper = styled(CredusWrapper)`
  > a {
    text-decoration: none;
  }
`;

export const AlertWrapper = styled.div`
  margin: 20px 0px 0px;
`;

const ColoredText = styled.span`
  color: ${color.primary};
`;

const FormWrap = styled.form`
  margin-top: 3.6rem;
  height: 524px;
  background: #f5f6f8;
  border-radius: 4px;
  padding: 72px 72px 55px;
`;

const CredusButtonWrap = styled(CredusButton)`
  margin-top: 2.9rem;
  width: 100%;
`;

const DividerWrap = styled(Divider)`
  width: 1px;
  height: 19px;
  background: #d9d9d9;
`;

const PasswordWrap = styled.div`
  position: relative;
  margin-top: 1.9rem;
  > span {
    cursor: pointer;
    position: absolute;
    right: 9px;
    top: 47px;
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
    padding-right: 10px;
    color: rgba(0, 9, 41, 0.58);
  }
`;

const WrappedLink = styled(Link)`
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  margin-left: 5px;
  text-decoration: none;
`;
